import { account, signIn, signOut } from "~/web/src/auth";
import { billingOn } from "~/web/src/billing-on";
import { Popover } from "~/web/src/popover";
import { navigate } from "~/web/src/router";
import { SignInIcon } from "./components/icons";

// Our own account menu: an initials button opening a popover with the name,
// email and org, the org's billing page when billing is on, the API keys
// page — both only once the address is verified (decision 6) — and sign-out
// (spec: own-auth-spec.md). No profile page in v1: a landing sign-up has no
// name, so the initials come from the address.

function initials(name: string | null, email: string): string {
  const src = name?.trim() || email || "?";
  const parts = src.split(/\s+/);
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (last ? first + last : src.slice(0, 2)).toUpperCase();
}

/** Render only when authState is ready (account is set). */
export function UserMenu({ signinIfLoggedOut }: { signinIfLoggedOut?: boolean }) {
  const a = account.value;
  if (!a) {
    if (!signinIfLoggedOut) {
      return null;
    }
    return (
      <Popover
        label={<SignInIcon size={16} />}
        buttonClass="avatar"
        title="Account menu"
        panel="popover menu"
      >
        {() => (
          <>
            <button type="button" class="btn ghost sm" onClick={() => signIn(location.href)}>
              Sign in
            </button>
          </>
        )}
      </Popover>
    );
  }
  const email = a.email;
  const name = a.name || null;
  const verified = a.verifiedAt !== null;
  return (
    <Popover
      label={initials(name, email)}
      buttonClass="avatar"
      title="Account menu"
      panel="popover menu"
    >
      {(close) => (
        <>
          <span class="menu-name">{name ?? email}</span>
          {name && <span class="dim">{email}</span>}
          <span class="dim">{a.org.name}</span>
          {billingOn && verified && (
            <a
              class="btn ghost sm"
              href="/billing"
              onClick={(e) => {
                e.preventDefault();
                close();
                navigate("/billing");
              }}
            >
              Billing
            </a>
          )}
          {verified && (
            <a
              class="btn ghost sm"
              href="/api-keys"
              onClick={(e) => {
                e.preventDefault();
                close();
                navigate("/api-keys");
              }}
            >
              API keys
            </a>
          )}
          <button type="button" class="btn ghost sm" onClick={() => void signOut()}>
            Sign out
          </button>
        </>
      )}
    </Popover>
  );
}
